import { render, staticRenderFns } from "./Customerbanonsale.vue?vue&type=template&id=9ba82696&"
import script from "./Customerbanonsale.vue?vue&type=script&lang=js&"
export * from "./Customerbanonsale.vue?vue&type=script&lang=js&"
import style0 from "./Customerbanonsale.vue?vue&type=style&index=0&id=9ba82696&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ba82696')) {
      api.createRecord('9ba82696', component.options)
    } else {
      api.reload('9ba82696', component.options)
    }
    module.hot.accept("./Customerbanonsale.vue?vue&type=template&id=9ba82696&", function () {
      api.rerender('9ba82696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Customerbanonsale/Customerbanonsale.vue"
export default component.exports